

import LoginPage from './Pages/Login/LoginPage';
import Base from './Pages/Private/Base/Base';
import Dashboard from './Pages/Private/Dashboard/Dashboard';
import User from './Pages/Private/User/User';
import Order from './Pages/Private/Order/Order';
import PDFBlock from './UI/PDF/PDFBlock';
//import ErrorPage from './Pages/ErrorPage';
import UserProfileVer2 from './Pages/Private/User/UserProfileVer2';
import UserDetail from './Pages/Private/User/UserDetail';

import { Routes, Route, Navigate } from 'react-router-dom';

import ProtectedRoute from './Pages/Private/Base/ProtectedRoute';
import { useSelector } from 'react-redux';

// Helper function to build routes based on user role
const buildPrivateRoutes = (authUser) => {
  const routes = [
    <Route key="home" index element={<Dashboard />} />,
    <Route key="order" path="order/:orderno" element={<Order />} />,
    <Route key="orderpdf" path="order/:orderno/pdf" element={<PDFBlock />} />,
    <Route key="profile" path="profile" element={<UserProfileVer2 />} />
  ];

  // Add User Management routes for non-Standard users
  if (authUser?.role !== 'Standard') {
    routes.push(<Route key="user" path="user" element={<User />} />);
    routes.push(<Route key="userdetail" path="user/:id" element={<UserDetail />} />);
  }

  return routes;
};

function App() {
  const authUser = useSelector((state) => state.auth.authUser);

  const privateRoutes = buildPrivateRoutes(authUser);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        path="/"
        element={
          <ProtectedRoute user={authUser}>
            <Base />
          </ProtectedRoute>
        }
      >
        {privateRoutes}
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
